import { useContext, useEffect, useState } from 'react';
import { AppFilterProps, ReactChildren, SelectOptions, ValuesOfAny } from '../interfaces/Common';
import { AuthContext } from '../Helpers/Contexts/authContext';
import { Navigate, useLocation } from 'react-router-dom';
import routes from './routes';
import { getFileUrl } from './apiService';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import { Job, MatchLevel } from '../interfaces/Placements';
import KenLoader from '../GlobalComponents/KenLoader';

export const getCombinedString: (array: Array<string>, seperator?: string) => string = (array: Array<string>, seperator?: string) => {
  let arrayString: string = '';
  let customSeperator = seperator ? seperator : ',';
  array.forEach((items: string, index: number) => {
    if (arrayString === '') {
      arrayString = `${items}${customSeperator} `;
    } else if (index === array.length - 1) {
      arrayString = arrayString + `${items}`;
    } else {
      arrayString = arrayString + `${items}${customSeperator} `;
    }
  });
  return arrayString;
};

export const splitCombinedStringintoArray = (value: string, seperator?: string) => {
  let customSeperator = seperator ? seperator : ',';
  return value.split(customSeperator);
};

export const handleFilterData: (key: string, array: Array<any>) => Array<SelectOptions> = (key: string, array: Array<any>) => {
  const set = new Set();
  const handleNull = (data: string) => {
    if (data && data !== null) {
      set.add(data);
    }
  };
  for (let i = 0; i < array?.length; i++) {
    if (array[i]) {
      const category = array[i][key] as string;
      if (category && `${category}`.includes(';')) {
        const categoryArray = category?.split(';');
        for (let j = 0; j < categoryArray.length; j++) {
          handleNull(categoryArray[j]);
        }
      } else {
        handleNull(category);
      }
    }
  }
  return [...set].map((items) => {
    return { label: items, value: items };
  }) as Array<SelectOptions>;
};

export const getYears: (start: number) => Array<SelectOptions> = (start: number) => {
  const array: Array<SelectOptions> = [];
  const date = new Date();
  for (let i = start; i <= date.getFullYear(); i++) {
    array.push({
      label: `${i}`,
      value: `${i}`,
    });
  }
  return array.reverse();
};

export const PublicRoute: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const {
    state: { isAuthenticated },
  } = useContext(AuthContext);
  console.log(isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={routes.placements} />;
  }
  return children;
};

export const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const {
    state: { isAuthenticated },
  }: any = useContext(AuthContext);

  const { pathname } = useLocation();

  // Check context OR localStorage
  const storedUser = localStorage.getItem('user');
  const authenticated = isAuthenticated || !!storedUser;

  // If not authenticated → go to login
  if (!authenticated) {
    return <Navigate to={routes.login} replace />;
  }

  // If already authenticated but on login → redirect to placements
  if (pathname === routes.login) {
    return <Navigate to={routes.placements} replace />;
  }

  // Otherwise → show protected page
  return <>{children}</>;
};

export const AppFilterFunction: (props: AppFilterProps) => Array<any> = (props) => {
  const { filterData, data } = props;
  if (Object.keys(filterData).length === 0) {
    return data;
  }

  const filteringData = { ...filterData };
  let sampleEventData = [...data];
  for (const i in filteringData) {
    const filteredArray = [];
    for (let j = 0; j < sampleEventData.length; j++) {
      const element = sampleEventData[j];
      if (element[i] !== null) {
        if (`${element[i]}`.toLowerCase().includes(`${filteringData[i]}`.toLowerCase())) {
          filteredArray.push(element);
        }
      }
    }
    sampleEventData = [...filteredArray];
  }
  return sampleEventData;
};

export function pad(n: string, width: number, z?: string) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const handleFiles = async (e: React.ChangeEvent<HTMLInputElement>, files: any, types?: Array<string>, size?: number) => {
  // File Check
  if (!e.target.files) {
    return { message: 'Please Upload File', success: false };
  }
  const getFile = e.target.files[0];
  const customSize = size ? size : 2000000;

  // File Type Check
  if (types) {
    const getMatch: Array<string> = types?.filter((items) => {
      return items === getFile.type;
    });
    if (getMatch.length === 0) {
      return {
        message: `Only the ${types.map((items) => {
          return `${items} `;
        })} formats are accepted`,
        success: false,
      };
    }
  }

  // File Size Check
  if (getFile.size > customSize) {
    return { message: 'File is larger than 1MB', success: false };
  }

  return await toBase64(e.target.files[0]);
};

export const moneyValidator = (start: string, end: string) => {
  const salary = start === end;
  return salary ? `${start} LPA` : `${start}-${end} LPA`;
};

export const rangeValidatorPayload = (year: string) => {
  const getYears = year.split('-');
  if (getYears.length === 2) {
    return [parseInt(getYears[0]), parseInt(getYears[1])];
  } else if (getYears.length === 1) {
    return [parseInt(getYears[0]), parseInt(getYears[0])];
  } else {
    return '';
  }
};

export const uniqueArrayCreator = (array: Array<any>, key: string) => {
  return Array.from(
    new Set([
      ...array?.map((items: any) => {
        return items[key];
      }),
    ])
  );
};

export const registeredDatas = (array: Array<any>, objectKey: string) => {
  const newObject: ValuesOfAny = {};
  array?.forEach((items: any) => {
    const keyValue = items[objectKey];
    const date = moment(keyValue).format('Do MMMM YYYY');
    items['find'] = date;
    if (newObject.hasOwnProperty(date)) {
      newObject[date].push({ ...items });
    } else {
      newObject[`${date}`] = [items];
    }
  });
  return newObject;
};

export const copyFunction = (text: string) => {
  const clipboardItem = new ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) });
  navigator.clipboard
    .write([clipboardItem])
    .then(() => {
      enqueueSnackbar({ message: 'Link copied', variant: 'success', autoHideDuration: 1000 });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const removeHTMLTags = (htmlString: string) => {
  return htmlString.replace(/<[^>]*>/g, '');
};

export const toBase64: (file: any) => Promise<unknown> = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export function removeNullKeys(obj: any) {
  for (let key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      removeNullKeys(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
  return obj;
}
export const splitBase64 = (base64: string) => {
  const splitData = base64.split(',');
  return splitData[1];
};

const createImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();

    if (!src.startsWith('data:')) {
      image.crossOrigin = 'anonymous';
    }

    image.onload = () => resolve(image);

    image.onerror = (e) => {
      console.error(`Image failed to load: ${src}`);
      reject(new Error(`Failed to load image: ${src}`));
    };

    image.src = src;
  });

export const getCroppedImg = async (
  imageSrc: string,
  croppedAreaPixels: { width: number; height: number; x: number; y: number },
  imageType: string = 'imag/png',
  outputType: 'base64' | 'url' = 'base64'
): Promise<string> => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) throw new Error('No 2D context');

  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  ctx.drawImage(image, croppedAreaPixels.x, croppedAreaPixels.y, croppedAreaPixels.width, croppedAreaPixels.height, 0, 0, croppedAreaPixels.width, croppedAreaPixels.height);

  if (outputType === 'url') {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) throw new Error('Canvas is empty');
        const blobUrl = URL.createObjectURL(blob);
        resolve(blobUrl);
      }, imageType);
    });
  }

  // Default to base64
  return canvas.toDataURL(imageType);
};

export const generateYear = (limit: number = 2000) => {
  const endYear = moment().year();
  const yearList = [];
  for (let year = limit; year <= endYear; year++) {
    yearList.push(year);
  }

  return yearList;
};

// optionally export this if you need it elsewhere

export const mapJobsToUI = (jobsdata: any[], userSkills: string[] = []): Job[] => {
  const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const ord = (n: number) => {
    const j = n % 10,
      k = n % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  };

 const fmtDeadline = (iso?: string) => {
   if (!iso) return '';
   const d = new Date(iso);
   if (isNaN(+d)) return iso;
   return `${d.getDate()} ${shortMonths[d.getMonth()]}, ${d.getFullYear()}`;
 };


  const fmtStepDate = (iso?: string) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(+d)) return iso;
    const day = d.getDate();
    return `${day}${ord(day)} ${longMonths[d.getMonth()]}, ${d.getFullYear()}`;
  };

  const parseSkills = (s?: string) =>
    (s || '')
      .split(';')
      .map((t) => t.trim())
      .filter(Boolean);

  const extractHiringStepsDetailed = (job: any): { title: string; date: string }[] => {
    const records = job?.Job_Application_Steps__r?.records ?? [];

    if (Array.isArray(records) && records.length) {
      return records
        .slice()
        .sort((a: any, b: any) => String(a.Date__c || '').localeCompare(String(b.Date__c || '')))
        .map((r: any) => ({
          title: String(r.Name ?? r.Title ?? r.Step__c ?? '').trim(),
          date: fmtStepDate(r.Date__c),
        }))
        .filter((s) => s.title);
    }

    const keys = Object.keys(job).filter((k) => /^Hiring_Flow_Step_(\d+)__c$/.test(k) && job[k]);
    keys.sort((a, b) => {
      const na = parseInt(a.match(/\d+/)![0], 10);
      const nb = parseInt(b.match(/\d+/)![0], 10);
      return na - nb;
    });
    return keys.map((k) => ({ title: String(job[k]).trim(), date: '' })).filter((s) => s.title);
  };

  const computeMatch = (required: string[], have: string[]) => {
    if (!required.length || !have.length) {
      return { text: '—', level: 'unknown' as MatchLevel, hits: 0, total: required.length, ratio: -1 };
    }
    const haveSet = new Set(have.map((x) => x.toLowerCase()));
    const hits = required.filter((r) => haveSet.has(r.toLowerCase())).length;
    const ratio = hits / required.length;
    const level: MatchLevel = ratio >= 1 ? 'excellent' : ratio >= 0.67 ? 'good' : ratio >= 0.34 ? 'average' : 'poor';
    return { text: `${hits}/${required.length} skills match`, level, hits, total: required.length, ratio };
  };

  // 🔹 Salary Normalizer
  const normalizeSalary = (raw: any): string => {
    if (!raw) return '';
    let val = String(raw).trim();

    // Remove unwanted chars and standardize
    val = val.replace(/pm|per\s*month|\/month/gi, ''); // remove "pm" variations
    val = val.replace(/[₹,\s]/g, '').toLowerCase();

    // Handle shorthand "k" and "lpa"
    if (val.endsWith('k')) {
      val = String(parseFloat(val.replace('k', '')) * 1000);
    } else if (val.endsWith('lpa')) {
      val = val.replace('lpa', '').trim();
      return `₹ ${val} LPA`;
    }

    // Convert to number and format
    const num = Number(val);
    if (!isNaN(num)) {
      return `₹ ${num.toLocaleString('en-IN')} PM`;
    }

    // Fallback
    return `₹ ${raw}`;
  };

  // 🔹 Build rows
  const rows = (jobsdata || []).map((j, idx) => {
    const requiredSkills = parseSkills(j.Skills_Required__c);

    const steps = extractHiringStepsDetailed(j);

    const { text: match, level: matchLevel, hits: matchHits, total: matchTotal, ratio: matchRatio } = computeMatch(requiredSkills, userSkills);

    const salary = normalizeSalary(j.CTC__c);

    const logo = j.Company_Logo_URL__c || '';
    const tags = [j.Position_Type__c, j.Sector__c].filter(Boolean);

    const hiringSteps = steps.map((s) => s.title);

    const job: Job = {
      logo,
      title: j.Job_Role__c || j.Name || '',
      company: j.Recruiters_ID__r?.Name || j.Recruiters_ID__c || '',
      location: j.Location__c || '',
      deadline: fmtDeadline(j.Deadline__c),
      match,
      matchLevel,
      tags,
      salary,
      skills: requiredSkills,
      applicationSteps: steps,
      positionType: j.Position_Type__c || '',
      matchHits,
      matchTotal,
      matchRatio,
      hiringSteps,
      aboutJob: j.Job_Description__c,
      perks: j.Job_Perks__r || '',
      keyResponsibilities: j.Additional_Instructions__c || '',
      otherRequirements: j.Other_Requirements__c || '',
      jobId: j.Id,
    };

    return { job, score: matchRatio, hits: matchHits, idx };
  });

  rows.sort((a, b) => b.score - a.score || b.hits - a.hits || a.idx - b.idx);

  return rows.map((r) => r.job);
};

